
export default function PromoBanners() {
  return (
    <section className="py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Luna Moon Banner */}
        <div className="relative h-[400px] rounded-xl overflow-hidden mb-8">
          <img
            src="https://public.readdy.ai/ai/img_res/7d829948628087506e55d202d91a5ef8.jpg"
            alt="Luna Moon Collection"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/50 to-transparent flex items-center">
            <div className="px-12">
              <p className="text-white/80 text-sm tracking-widest mb-2">Nuestras</p>
              <h3 className="font-serif text-5xl font-bold text-white mb-4">LUNAMOON</h3>
              <p className="text-white/90 mb-6">🌙 NOVEDADES</p>
              <button className="px-8 py-3 bg-white text-stone-900 font-medium text-sm hover:bg-stone-100 transition-colors cursor-pointer whitespace-nowrap">
                Comprar
              </button>
            </div>
          </div>
        </div>

        {/* Two Column Banners */}
        <div className="grid md:grid-cols-2 gap-8">
          {/* Alta Cosmética */}
          <div className="relative h-[350px] rounded-xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Luxury%20skincare%20products%20collection%20with%20elegant%20serum%20bottles%20and%20cream%20jars%20on%20soft%20beige%20background%2C%20premium%20facial%20treatment%20products%2C%20sophisticated%20cosmetic%20packaging%2C%20professional%20beauty%20photography%2C%20warm%20ambient%20lighting%2C%20high-end%20skincare%20display&width=700&height=350&seq=altacosmetica&orientation=landscape"
              alt="Alta Cosmética"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end">
              <div className="p-8">
                <p className="text-white/80 text-sm italic mb-1">Alta</p>
                <h3 className="font-serif text-4xl font-bold text-white mb-4">COSMÉTICA</h3>
                <button className="px-6 py-2.5 bg-white text-stone-900 font-medium text-sm hover:bg-stone-100 transition-colors cursor-pointer whitespace-nowrap">
                  Descubrir
                </button>
              </div>
            </div>
          </div>

          {/* Packs Regalo */}
          <div className="relative h-[350px] rounded-xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20gift%20box%20set%20with%20premium%20beauty%20products%20including%20nail%20polish%20and%20skincare%20items%20wrapped%20with%20ribbon%20on%20soft%20pink%20background%2C%20luxury%20cosmetic%20gift%20pack%2C%20professional%20product%20photography%2C%20sophisticated%20packaging%20design%2C%20warm%20ambient%20lighting&width=700&height=350&seq=packsregalo&orientation=landscape"
              alt="Packs Regalo"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end">
              <div className="p-8">
                <h3 className="font-serif text-4xl font-bold text-white mb-2">PACKS REGALO</h3>
                <p className="text-white/90 mb-4">Hasta 40% de descuento</p>
                <button className="px-6 py-2.5 bg-white text-stone-900 font-medium text-sm hover:bg-stone-100 transition-colors cursor-pointer whitespace-nowrap">
                  Comprar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
